const CspTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      "#ebebeb",
        primary2color:      "#e6e6e6",
        primary3color:      "#efefef",
        accent1color:       "#b3e5fc",
        accent2color:       "#b3e0db",
        accent3color:       "#f0f5c4",
        accent4color:       "#d8d8d8", // Active breadcrumb color
        accent5color:       "#00cae4", // Button color
        textColor:          "#212121",
        canvasColor:        "#ffffff",
        alternateTextColor: "#212121",
    }
};

export default CspTheme;


/** WEBPACK FOOTER **
 ** ./src/themes/CspTheme.js
 **/